// extracted by mini-css-extract-plugin
module.exports = {"root":"CategoryService_root__24yl-","label":"CategoryService_label__2OWrq","location":"CategoryService_location__16NSl"};